module.exports = __webpack_public_path__ + "static/media/localu.86963b7e.png";